import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import {Link} from "react-router-dom";

import Navbar from '../inc/Navbar';
import Finddoctor from './Finddoctor';
function Doctorpage() {
  return (
    <div>
            <Navbar />
      <br />
      <br />
      <br />
      <br />
      <ScrollToTop smooth top="100" />
      <div className='krishnagarhomeo'>
      <div className="album py-1">

        <div className="container mt-3">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
              <li className="breadcrumb-item active" aria-current="page">Find Doctor</li>
            </ol>
          </nav>
          </div>
        </div>
        
      </div>
          <Finddoctor/>
    </div>

  )
}

export default Doctorpage